<!--
 * @Author: yinbing.liu
 * @Date: 2023-09-18 17:53:30
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-09-13 14:21:45
 * @FilePath: /fushigi/src/components/Menu/src/components/BasicMenuItem.vue
 * @Description:
-->
<script lang="ts" setup>
import { toRefs } from 'vue'
import { Menu } from 'ant-design-vue'
import { RoutesDataItem, hasChildRoute } from '@/utils/routes'
import ALink from '@/components/ALink/index.vue'
import { IApparatusCountState } from '@/store/apparatus'

interface Props {
  apparatusCount: IApparatusCountState
  routeItem: RoutesDataItem
}

const props = withDefaults(defineProps<Props>(), {})
const { routeItem, apparatusCount } = toRefs(props)
</script>
<template>
  <template
    v-if="
      routeItem.children && Array.isArray(routeItem.children) && hasChildRoute(routeItem.children)
    "
  >
    <Menu.ItemGroup :key="routeItem.path">
      <!-- <template #icon>
        <svg-icon v-if="routeItem.icon" :name="routeItem.icon" />
      </template> -->
      <template #title>
        <span class="menu-title h-20 text-[12px] mb-[8px]">{{ routeItem.title }}</span>
      </template>
      <basic-menu-item
        v-for="item2 in routeItem.children"
        :key="item2.path"
        :route-item="item2"
        :apparatus-count="apparatusCount"
      >
      </basic-menu-item>
    </Menu.ItemGroup>
    <Menu.Divider
      v-if="!routeItem?.meta?.lastRootItem"
      class="sidebar-group-divider"
      :class="{ noMB: routeItem.noDivider }"
    />
  </template>
  <template v-else>
    <Menu.Item :key="routeItem.path" class="sidebar-nav">
      <a-link :to="routeItem.path">
        <svg-icon v-if="routeItem.icon" class="size-[16px]" :name="routeItem.icon" />
        <span class="menu-title text-[14px]" :class="{ active: routeItem.icon }">
          {{ routeItem.title }}
          <span
            v-if="apparatusCount[routeItem.key as keyof IApparatusCountState] &&apparatusCount[routeItem.key as keyof IApparatusCountState] !== 0"
            >({{ apparatusCount[routeItem.key as keyof IApparatusCountState] }})</span
          >
        </span>
      </a-link>
    </Menu.Item>
    <Menu.Divider v-if="routeItem.islastItem" class="mt-[12px]! mr-[4px] ml-[4px] mb-[16px]!" />
  </template>
</template>

<style scoped lang="less">
.active {
  padding-left: 10px;
  width: 100%;
}

:deep(.ant-menu-item-group-title) {
  font-weight: 400;
  line-height: 20px;
  font-size: 12px;
  padding: 0;
  margin: 0 0 8px;
}

:deep(.ant-menu-item-group-list) {
  // overflow: hidden;

  .ant-menu-item {
    width: 100%;
    margin: 0;
  }
}

:deep(.ant-menu-item) {
  width: 100%;
  margin: 8px 0 0;
}
</style>
